import request from '../utils/request'

export function list(object) {
    return request.post('/my-product/list', object)
}

export function queryById(id) {
    return request.get('/my-product/'+id)
}

export function put(object) {
    return request.put('/my-product/',object)
}
